export default "__VITE_ASSET__d0VKfsxj__"